window.Currency = {
    formatMoney: function(cents, format) {
        if (typeof cents === "string") {
            cents = cents.replace('.', '');
        }
        var value = (cents / 100).toFixed(2);
        return value + " €";
    }
};
